import React from 'react';
import StorePolicy from '@/components/StorePolicies';
import Layout from '@/components/Layout';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import { getSSRStoreData } from '../../utils/ssrPageData';
import { useSSRSelector, useSetSSRStore } from '../../redux';
import { getRequiredCtxProps } from 'src/utils/getRequiredCtxProps';

function Policy(props) {
  useSetSSRStore(props.ssrStore);
  const storeData = useSSRSelector((state) => state.storeReducer.store);

  return (
    <Layout
      store={storeData}
      title={`Store policies`}
      Icon={storeData?.store_info?.logo_image}
      metaDescription={
        'Now order online from my whatsapp store & pay using 150+ UPI Apps'
      }
      OGImage={storeData?.store_info?.logo_image}
      isCustomDomain={props.isCustomDomain}
      {...props}
    >
      <StorePolicy {...props} />
    </Layout>
  );
}

export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx)) return {};
  let propData = {
    catalogCategories: [],
    catalogTags: [],
    collections: [],
  };

  const propType = await getSSRStoreData(ctx, {
    additionalDataToFetch: ['collections', 'categories'],
  });

  const extraProps = getRequiredCtxProps(ctx, propType);

  propData = { ...propData, ...propType };

  return { props: { ...propData, ...extraProps } };
}

export default Policy;
